import { Routes, Route } from 'react-router-dom'
import Home from './pages/Home'
import About from './pages/About'
import Contact from './pages/Contact'
import Downloads from './pages/Downloads'
import Projects from './pages/Projects'
import Services from './pages/Services'

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/downloads" element={<Downloads />} />
      <Route path="/projects" element={<Projects />} />
      <Route path="/services" element={<Services />} />
    </Routes>
  )
}

export default App
